"use strict";
(function sortingPlugin(global) {

  /**
  * Плагин для сохранения и загрузки сортировки в таблице.
  *
  * @class WebAccess.components.dataViews.gridPlugins.SortingPlugin
  * @extends WebAccess.Plugin
  * @since 5.2.0.1100
  */
  global.SortingPlugin = WA.Plugin.extend({
    name: 'SortingPlugin',

    // Расширяемый грид
    _grid: null,
    _useServer: false,
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    init: function (useServer) {
      this._useServer = useServer;
    },

    /**
    * Регистрирует плагин.
    *
    * @method WebAccess.components.dataViews.gridPlugins.SortingPlugin#register
    * @param {grid} Таблица.
    * @since 5.2.0.1100
    * @return {object} Ассоциативный массив, содержащий публичные методы.
    */
    register: function (grid) {
      var me = this;
      me._grid = grid;

      me._grid.bind(WA.CMP.DV.Grid.EVENT.BEFORE_GRID_INIT, me._onGridBeforeInit, me);
      me._grid.bind(WA.CMP.DV.Grid.EVENT.COLUMN_INIT, $.proxy(me._onColumnInit, me));
      me._grid.bind(WA.CMP.DV.Grid.EVENT.GRID_INIT, $.proxy(me._onGridInit, me));
      return {
        'reSortColumns': me._reSort
      }
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Хэндлер события до инициализации грида.
    * @method WebAccess.components.dataViews.gridPlugins.EditPlugin#_onGridBeforeInit
    * @param {string} containerSelector селектор контейнера для грида.
    * @param {Object} dataView представление данных.
    * @param {Object} columns описания всех колонок.
    * @param {Object} settings настройки грида.
    * @private
    * @since 5.2.0.1100
    */
    _onGridBeforeInit: function (containerSelector, dataView, columns, byref_settings) {
      var me = this;
      if (!me._useServer) {
        //   byref_settings.multiColumnSort = true;
      };
    },

    /**
    * Делаем все колонки сортируемыми
    * @method WebAccess.components.dataViews.gridPlugins.CheckboxPlugin#_onColumnInit
    * @param {object} byref_column колонка
    * @private
    * @since 5.2.0.1100
    */
    _onColumnInit: function (byref_column) {
      var isSpecialColumn = (byref_column.id.charAt(0) === '_');
      byref_column.sortable = !isSpecialColumn;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Хэндлер события инициализации грида.
    * @method WebAccess.components.dataViews.gridPlugins.SortingPlugin#onGridInit
    * @param {SlickGrid} slickGrid копмопнента грид.
    * @private
    * @since 5.2.0.1100
    */
    _onGridInit: function (slickGrid) {
      this._bindOnSort();
      this._restoreSorting();

    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Восстанавливает сохраненную сортировку при инициализации грида.
    * @method WebAccess.components.dataViews.gridPlugins.SortingPlugin#_restoreSorting    
    * @private
    * @since 5.2.0.1100
    */
    _restoreSorting: function () {
      var me = this;
      if (!me._useServer) {
        me._grid.bind(WA.CMP.DV.Grid.EVENT.AFTER_DATA_LOADED, function () {
          me._grid.reSortColumns();
        });
      }
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Пересортировка
    * @method WebAccess.components.dataViews.gridPlugins.SortingPlugin#_restoreSorting    
    * @private
    * @since 5.2.0.1304
    */
    _reSort: function () {
      var grid = this;
      var me = this;      
      var sortingColumns = _(grid.state.Sort).map(function (sortInfo) {
        return {
          columnId: sortInfo.Name,
          sortAsc: sortInfo.IsAsc
        };
      });

      grid.grid.setSortColumns(sortingColumns);

      _(sortingColumns).each(function (_column) {
        var column = _(grid._columns).findWhere({ id: _column.columnId });
        if (!column) return;

        var comparer = function (g1, g2) {
          var v1 = g1[column.field];
          var v2 = g2[column.field];
          var type = requisiteTypeToString(column.type);
          // Дробные и целые числа могут быть записаны в формате "1 234 567,34". Такая запись не конвертируется в число, поэтому берем значение без форматирования.
          if (type === 'float' || type === 'integer' || type === 'largeinteger') {
            v1 = g1[column.id];
            v2 = g2[column.id];
          }
          
          return WA.utils.compareData(v1, v2, type);
        };

        grid.grid.setSortColumn(_column.columnId, _column.sortAsc);
        grid.dataView.sort(comparer, _column.sortAsc);
      });

      //проверяем была ли добавлена новая строка в таблицу, добавленной строке устанавливаем ранг - 1000000
      if (grid._table && WA.ENV.browser.name !== 'IE') {
        var rowsArr = grid._table.rows.toArray();
        for (var i = 0; i < rowsArr.length; i++) {
          var row = rowsArr[i];
          if (row._isNew) {
            var rowData = grid.dataView.getItemById(row.id);
            if (rowData) {
              rowData.rank = 1000000;
            }
          };
        };
        //сортируем в обратном порядке, так новая строка всегда будет последней
        grid.dataView.fastSort('rank', false);
      };

      grid.grid.invalidate();
      grid.grid.render();
    },

    /**
    * Навешивается на событие смены сортировки что бы сохранить состояние и загрузить новые данные.
    * @method WebAccess.components.dataViews.gridPlugins.SortingPlugin#_bindOnSort    
    * @private
    * @since 5.2.0.1100
    */
    _bindOnSort: function () {
      var me = this;

      me._grid.grid.onSort.subscribe(function (e, args) {
        me._grid.updateState({
          Sort: [{ Name: args.sortCol.id, IsAsc: args.sortAsc }]
        });

        if (me._useServer) {
          me._grid.reloadData();
        } else {

          var comparer = function (g1, g2) {
            var v1 = g1[args.sortCol.field];
            var v2 = g2[args.sortCol.field];
            var type = requisiteTypeToString(args.sortCol.type);
            // Дробные и целые числа могут быть записаны в формате "1 234 567,34". Такая запись не конвертируется в число, поэтому берем значение без форматирования.
            //CREVIEW Шамов А.: Тут Int64?
            if (type === 'float' || type === 'integer') {
              v1 = g1[args.sortCol.id];
              v2 = g2[args.sortCol.id];
            }
            return WA.utils.compareData(v1, v2, type);
          };

          me._grid.dataView.sort(comparer, args.sortAsc);
        }
      });
    }
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
  });

})(WA.components.dataViews.gridPlugins);